import FastMarquee from "react-fast-marquee";
import { MARQUEE_ITEMS } from "@/data/content";

export default function Marquee() {
  return (
    <section
      data-testid="marquee"
      aria-label="Placement destinations"
      className="overflow-hidden border-y border-brand-line bg-brand-surface py-7"
    >
      <FastMarquee speed={32} gradient={false} pauseOnHover>
        {MARQUEE_ITEMS.map((item, i) => (
          <span key={item} className="mx-10 flex items-center gap-20">
            <span
              className={`font-serif text-3xl md:text-4xl ${
                i % 2 === 1 ? "italic text-brand-terra" : "text-brand-green"
              }`}
            >
              {item}
            </span>
            <span aria-hidden="true" className="text-xl text-brand-terra">
              ✦
            </span>
          </span>
        ))}
      </FastMarquee>
    </section>
  );
}
